import { FC } from 'react';

import { Form } from 'antd';
import { Input, Label } from 'ui';

import { EventTicketType } from 'types/events/eventTypes';
import { OfferType } from 'types/promoters/promoterTypes';

import EventOfferSetTicketType from '../event-offer-set-ticket-type';
import s from './EventOfferPerEvent.module.scss';

interface EventOfferPerEventProps {
  tickets?: EventTicketType[];
  ticketTypes?: {
    ticketType?: EventTicketType;
    ticketTypeId?: string;
    id?: string;
    priceToBeSold?: number;
    minimumNumberOfTicketsToBeBought?: number;
  }[];
  setTicketTypes: (
    ticketTypes: {
      id: string;
      ticketType: EventTicketType;
      priceToBeSold?: number;
      minimumNumberOfTicketsToBeBought?: number;
    }[],
  ) => void;
}

const EventOfferPerEvent: FC<EventOfferPerEventProps> = ({
  tickets,
  ticketTypes,
  setTicketTypes,
}) => {
  return (
    <div className={s.wrapper}>
      <EventOfferSetTicketType
        offerType={OfferType.perDifferentEvents}
        ticketTypes={ticketTypes}
        tickets={tickets}
        setTicketTypes={setTicketTypes}
      />
      <div className={s.row}>
        <div className={s.item}>
          <Label>
            Maximum tickets that can be sold with this offer (leave blank for unlimited tickets)
          </Label>
          <Form.Item name="numberOfTicketsAvailable" label="">
            <Input.Number
              style={{ width: '100%' }}
              name="numberOfTicketsAvailable"
              size="middle"></Input.Number>
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default EventOfferPerEvent;
